import _toConsumableArray from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import Vue from 'vue';
import Router from 'vue-router';
import Routes from "./routes";
import { getAuthStorage } from '@/api/service-localstorage';
import store from '@/store';
Vue.use(Router);

var createRouter = function createRouter() {
  return new Router({
    routes: [{
      path: '',
      beforeEnter: function beforeEnter(to, from, next) {
        if (getAuthStorage()) {
          var currentModule = store.state.Menu.currentModule || [];
          var type = currentModule[0].type;
          var path = type; // 如果存在appid 说明进入免登录状态，直接进行推出重新刷新当前页面

          if (to.query.appid) {
            localStorage.clear();
            sessionStorage.clear();
            location.reload(true);
          } else {
            next(path || '');
          }
        } else {
          next({
            name: 'login',
            query: to.query
          });
        }
      }
    }].concat(_toConsumableArray(Routes))
  });
};

var router = createRouter(); // 重置路由权限

export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher;
} // 基础路由

export default router;